import { fetch } from "../utils/scsFetch";
import { URL_SURVEY_API } from '../utils/constEnvVariables'

let filtersCatalogCache = null;
let filtersCatalogPromise = null;

const cloneFiltersCatalogMap = (filtersCatalogMap) => {
    if (!(filtersCatalogMap instanceof Map)) return new Map();
    return new Map(
        Array.from(filtersCatalogMap.entries()).map(([questionType, filters]) => [questionType, [...filters]])
    );
};

const groupFiltersByQuestionType = (filters = []) => {
    return filters.reduce((filtersMap, filter) => {
        const questionType = filter?.questionType || "UNKNOWN";
        const currentFilters = filtersMap.get(questionType) || [];
        currentFilters.push(filter);
        filtersMap.set(questionType, currentFilters);
        return filtersMap;
    }, new Map());
};

export const getUserInfo = function (accessToken) {
    return fetch(`${URL_SURVEY_API}/surveys/userInfo`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    });
}

export const getSurveyConfiguration = function (code, accessToken) {
    return fetch(`${URL_SURVEY_API}/surveys/${code}`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    });
}

export const getSuppSurveyConfiguration = function (surveyId, locale, accessToken, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/COC" : "surveys";
    let requestOptions = { method: "GET", headers: { Authorization: `Bearer ${accessToken}` } };
    return fetch(`${URL_SURVEY_API}/${pathParam}/${surveyId}/?locale=${locale}`, requestOptions);
}

export const getFiltersCatalog = async (accessToken, options = {}) => {
    const { forceRefresh = false } = options;

    if (!forceRefresh && filtersCatalogCache) {
        return cloneFiltersCatalogMap(filtersCatalogCache);
    }

    if (!forceRefresh && filtersCatalogPromise) {
        return filtersCatalogPromise.then((filtersCatalogMap) => cloneFiltersCatalogMap(filtersCatalogMap));
    }

    filtersCatalogPromise = fetch(`${URL_SURVEY_API}/surveys/catalog/filters`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${accessToken}`,
        }
    })
        .then((response) => {
            const groupedFilters = groupFiltersByQuestionType(response);
            filtersCatalogCache = groupedFilters;
            return groupedFilters;
        })
        .catch((error) => {
            filtersCatalogCache = null;
            throw error;
        })
        .finally(() => {
            filtersCatalogPromise = null;
        });

    return filtersCatalogPromise.then((filtersCatalogMap) => cloneFiltersCatalogMap(filtersCatalogMap));
}
